import { Pipe, PipeTransform } from '@angular/core';

import * as Humanize from 'humanize-plus';

import { Utils } from 'app/utils/utils';

@Pipe({
  name: 'humanizeInt',
  standalone: false,
})
export class HumanizeNumberPipe implements PipeTransform {
  transform(value: number, precision = 1, cutoff = 1000, intPrecision?): string {
    if (!isNaN(value)) {
      if (value < cutoff) {
        return Humanize.intComma(value, intPrecision);
      }

      let compactValue = value;
      if (precision === 0) {
        // https://github.com/HubSpot/humanize/issues/97
        compactValue = Utils.compact(
          compactValue,
          3 * Math.floor((Number(compactValue).toFixed(0).length - 1) / 3)
        );
      }

      return Humanize.compactInteger(compactValue, precision);
    }
  }
}
